import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.title',
    defaultMessage: 'Screenings',
  },
  subtitleReadonly: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.subtitleReadonly',
    defaultMessage:
      'Application screenings will run in the order of active screening providers displayed here. ' +
      'To make changes to this order, contact your admin.',
  },
  subtitleEditMode: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.subtitleEditMode',
    defaultMessage:
      'Drag and drop the active screening providers to rearrange the order of your screening process.',
  },
  noActiveProviders: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.noActiveProviders',
    defaultMessage: 'No active providers',
  },
  activeScreeningProviders: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.activeScreeningProviders',
    defaultMessage: 'Active Screening Providers',
  },
  inactiveScreeningProviders: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.inactiveScreeningProviders',
    defaultMessage: 'Inactive Screening Providers',
  },
  code: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.code',
    defaultMessage: 'Code',
  },
  noInactiveProviders: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.noInactiveProviders',
    defaultMessage: 'No inactive providers',
  },
  on: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.on',
    defaultMessage: 'On',
  },
  off: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.off',
    defaultMessage: 'Off',
  },
  required: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.required',
    defaultMessage: 'Required',
  },
  overlappingMethodsTooltip: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.overlappingMethodsTooltip',
    defaultMessage:
      'This provider cannot be activated because it shares one or more screening methods ' +
      'with an already active provider.',
  },
  notConfiguredTooltip: {
    id: 'App.ViewProperty.IntegrationsSetup.ScreeningsSetup.notConfiguredTooltip',
    defaultMessage:
      'This screening provider is unavailable because required configuration is missing. ' +
      'Please contact support to enable access.',
  },
});

export default messages;
